module.exports = __webpack_public_path__ + "img/img9.3d8ba7d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/case/05/img9.png
// module id = 248
// module chunks = 0